import React, { lazy } from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Protocolo Flash: Triggers y Salida Fantasma',
    desc: 'La raíz del problema. Por qué tu perro entra en pánico antes de que cierres la puerta, qué señales disparan el miedo y cómo desactivarlas una por una. El Protocolo de Salida Fantasma para que tus primeros pasos fuera del depto sean invisibles para su sistema nervioso.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — La Fortaleza de Cristal',
    desc: 'Arquitectura de contención. Cómo zonificar tu departamento para que tu perro tenga menos espacio para angustiarse, cómo construir el Refugio de Calma perfecto en menos de una hora y cómo instalar el sistema de ruido blanco que neutraliza todos los sonidos del edificio.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Ocupación Estratégica',
    desc: 'El Método de la Mandíbula Cansada. Cómo agotar la mente de tu perro antes de salir para que llegue al minuto 20 demasiado ocupado para entrar en pánico. Protocolo de rellenos de larga duración, juegos de olfato en 2x2 metros y la secuencia de ocupación que lleva del movimiento al descanso profundo.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Química de la Calma',
    desc: 'Bio-hacking canino. Qué hormona sabotea el proceso, cómo bajarla desde la dieta, qué horario de alimentación potencia la calma, qué alimentos disponibles en cualquier supermercado argentino reducen el cortisol basal de tu perro y qué suplementos naturales de farmacia hacen todo el sistema más efectivo.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Mapa de la Libertad: 21 Días',
    desc: 'La hoja de ruta completa. De la crisis a la convivencia invisible en 21 días. Cómo escalar el tiempo de soledad sin generar recaídas, qué hacer el día que el sistema falla, cómo validar que el silencio es real y el protocolo de mantenimiento que sostiene el resultado de por vida.'
  }];
  const includes = ['Explicación clara sin tecnicismos', 'Protocolo paso a paso aplicable desde hoy', 'Tablas, trackers y checklists listos para completar', 'Casos reales de perros en deptos argentinos', 'Versión resumen para consulta rápida', 'Compatible con cualquier raza y cualquier tamaño', 'Diseño premium — Listo para usar en celular o impreso'];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-280">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0%,rgba(255,165,0,0.05),transparent_70%)] pointer-events-none" data-id="element-281"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-282">
        <FadeIn data-id="element-283">
          <div className="text-center mb-16" data-id="element-284">
            <div className="inline-block bg-orange-500/10 text-orange-400 px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-orange-500/20 uppercase" data-id="element-285">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-4xl md:text-6xl text-white mb-4 tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-286">
              🏆 MÉTODO{' '}
              <span className="text-orange-400" data-id="element-287">SILENCIO TOTAL™</span>
            </h2>
            <p className="text-lg md:text-xl font-sans font-medium opacity-90 text-[#FFFFFF]" data-id="element-288">
              5 Tomos + 4 Bonos · 180+ páginas · Todo resuelto.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-20" data-id="element-289">
            <div className="lg:col-span-7 space-y-5" data-id="element-290">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-950/60 p-5 md:p-6 rounded-2xl border border-white/5" data-id="element-291">
                  <div className="flex items-start" data-id="element-292">
                    <span className="text-3xl md:text-4xl mr-5" data-id="element-293">
                      {tomo.icon}
                    </span>
                    <div data-id="element-294">
                      <h3 className="text-lg md:text-xl font-sans font-bold text-white mb-2 leading-tight" data-id="element-295">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-300 text-sm leading-relaxed font-sans opacity-90" data-id="element-296">
                        {tomo.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="lg:col-span-5 sticky top-24 hidden lg:block" data-id="element-297">
              <div className="relative w-full max-w-md mx-auto" data-id="element-298">
                <div className="absolute inset-0 bg-orange-500/10 blur-3xl rounded-full" data-id="element-299"></div>
                <img src="https://cdn.magicpatterns.com/uploads/vcQjLEqDtd9kUSjVTfJbcF/Mockup-Prodcuto-3-_2__(1).webp" alt="Método Silencio Total" className="relative z-10 w-full h-auto" width={400} height={400} loading="lazy" data-id="element-300" />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-301">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-orange-500/50 to-transparent" data-id="element-302" />
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-orange-500/5 blur-3xl rounded-full" data-id="element-303"></div>

            <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-12 font-[Montserrat,_sans-serif]" data-id="element-304">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-305">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-4 bg-white/5 border border-white/5 p-5 rounded-2xl" data-id="element-306">
                  <CheckCircle2 className="w-6 h-6 text-orange-400 flex-shrink-0" data-id="element-307" />
                  <span className="text-white font-bold text-sm md:text-base tracking-wide font-sans" data-id="element-308">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};